import { useState } from "react";

/**
 * Purchase payload — mirrors the extended `POST /customers/me` (`createCustomer`)
 * from GRWBKK-1642 (`hardware` + `shippingCharge`). Kept minimal until the SDK
 * is bumped and the real types are available.
 */
export interface PurchasePayload {
  hardware?: {
    device: string;
    quantity: number;
    shippingCountry: string;
  };
  shippingCharge?: {
    /** Minor units (cents). */
    amount: number;
    currency: string;
    description: string;
  };
}

// MOCK of the SDK `createCustomer`. Swap for the real
// `getClient().customer.createCustomer(payload)` once billing-client-api is
// bumped (GRWBKK-1642) — together with the Stripe tokenize + 3DS/SCA sequence
// reused from usePaymentMethodForm. Card data never enters this payload.
const createCustomerMock = async (_payload: PurchasePayload): Promise<void> => {
  await Promise.resolve();
};

export interface UsePurchase {
  /** Submits the order; resolves true on success, false on failure. */
  purchase: (payload: PurchasePayload) => Promise<boolean>;
  loading: boolean;
}

export const usePurchase = (): UsePurchase => {
  const [loading, setLoading] = useState(false);

  const purchase = async (payload: PurchasePayload): Promise<boolean> => {
    setLoading(true);
    try {
      await createCustomerMock(payload);
      return true;
    } catch {
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { purchase, loading };
};
